import { initContract } from "@ts-rest/core";
import { StreamableFile } from "@nestjs/common";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    schedulesReportDateBoundsQuery,
    schedulesReportDateBoundsResponseSchema,
    schedulesReportExportQuery,
    schedulesReportQuery,
    schedulesReportResponseWithPresentationSchema,
} from "@common/schemas/domains/accounting/schedules-report.schema";

const c = initContract();

export const schedulesReportContract = c.router(
    {
        getSchedulesReport: {
            method: "GET",
            path: "/",
            query: schedulesReportQuery,
            responses: {
                200: schedulesReportResponseWithPresentationSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        exportSchedulesReport: {
            method: "GET",
            path: "/export",
            query: schedulesReportExportQuery,
            responses: {
                200: c.type<StreamableFile>(),
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        getSchedulesReportDateBounds: {
            method: "GET",
            path: "/date-bounds",
            query: schedulesReportDateBoundsQuery,
            responses: {
                200: schedulesReportDateBoundsResponseSchema,
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    { pathPrefix: "/accounting-reports/schedules" },
);
